import { useRef, useCallback } from 'react'
import {
  Toolbar as ReactAdminToolbar,
  SaveButton,
  DeleteButton,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  toolbar: {
    justifyContent: 'space-between',
  },
  saveButton: {
    marginRight: 16,
  },
}))

const Toolbar = (props) => {
  const {
    pristine,
    mutationMode,
    handleSubmitWithRedirect: raHandleSubmit,
    ...rest
  } = props
  const submittingRef = useRef(false)
  const classes = useStyles()

  const handleSubmitWithRedirect = useCallback(
    (redirect) => {
      if (submittingRef.current) return
      submittingRef.current = true
      raHandleSubmit(redirect)
    },
    [raHandleSubmit]
  )

  return (
    <ReactAdminToolbar
      {...rest}
      handleSubmitWithRedirect={handleSubmitWithRedirect}
      className={classes.toolbar}
    >
      <div>
        <SaveButton
          {...rest}
          handleSubmitWithRedirect={handleSubmitWithRedirect}
          disabled={pristine}
          label='Save'
          redirect={false}
          className={classes.saveButton}
        />
        <SaveButton
          {...rest}
          handleSubmitWithRedirect={handleSubmitWithRedirect}
          disabled={pristine}
          label='Save and Quit'
          redirect='list'
        />
      </div>
      <DeleteButton redirect='list' label='Delete Species' />
    </ReactAdminToolbar>
  )
}

export default Toolbar
